module.exports = __webpack_public_path__ + "img/noMenu.91748fa6.png";